import styled from "@emotion/styled";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Link } from "components/Common/Link";

export const CrossNavigationBannerLink = styled(Link)(({ theme }) => ({
	alignItems: "flex-start",
	backgroundColor: theme.project.colors.backgroundColors.selected,
	color: theme.project.colors.primaryColors.main,
	display: "flex",
	gap: "12px",
	padding: "14px 16px",
	textDecoration: "none",
	width: "100%",
	"&:hover": {
		textDecoration: "none"
	}
}));

export const CrossNavigationBannerIcon = styled(InfoOutlinedIcon)(({ theme }) => ({
	color: theme.project.colors.primaryColors.main,
	flexShrink: 0,
	marginTop: "2px"
}));

export const CrossNavigationBannerText = styled.span(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.primaryColors.main,
	lineHeight: "20px"
}));

export const CrossNavigationBannerAction = styled.span({
	fontWeight: 500,
	textDecoration: "underline"
});
